import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  CardMedia,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  root: {
    alignItems: 'center',
  },
  cardcontent: {
    padding: '0',
    opacity: '0.8',
    '&:hover': {
      borderColor: '#dddee1',
      boxShadow: '5px',
      cursor: 'pointer',
      opacity: 1
    }
  },
  cardImage: {
    padding: '0',
  },
  statsItem: {
    alignItems: 'center',
    display: 'flex',
    margin: '5px 0 10px 0'
  },
  statsIcon: {
    marginRight: theme.spacing(1)
  },
  inputBox: {
    padding: '0',
    width: '5ch',
    margin: '-8px 10px 0 10px',
    fontWeight: 'bold',
    height: '30px'
  },
  topIcons: {
    float: 'right',
    margin: '5px',
    paddingTop: '4px',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    borderRadius: '5px',
    height: '40px',
    width: '92px',
    color: '#757575'
  },
  media: {
    height: 100,
    width: 150,
    paddingTop: '50.25%', // 16:9
  },
});

class TemplateCard extends React.Component {
  render() {
    const {
      classes,
      className,
      template,
      selected,
      ...rest
    } = this.props;

    return (
      <Card
        className={clsx(classes.root, className, classes.cardcontent)}
        style={ selected ? { opacity: 1 } : {}}
        {...rest}
      >
        <CardContent className={classes.cardImage}>
          <Box
            justifyContent="center"
            mb={3}
          >
            <CardMedia
              className={classes.media}
              image={template.icon_192}
            />
          </Box>
        </CardContent>
        <Box padding="0 16px 16px 16px" textAlign="center">
          <Grid
            container
            spacing={1}
          >
            <Grid item xs={12}>
              <Typography
                display="inline"
                variant="h4"
              >
                {template.name}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Card>
    );
  }
}

TemplateCard.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  template: PropTypes.object.isRequired
};

export default withStyles(styles)(TemplateCard);
